import Button from "@components/ui/buttons/Button";
import { Text1, Text2 } from "@components/ui/texts/Texts";
import { useEffect, useState } from "react";
import DataGrid from "@components/ui/tables/DataGrid";
import { transformBroadcastsToTable } from "@components/ui/tables/transformToTables";
import { useProjectStore } from "@store/projectStore";
import { CreateBroadcastModal } from "@components/modals/CreateBroadcastModal";
import { ModifyBroadcastModal } from "@components/modals/ModifyBroadcastModal";
import ConfirmationModal from "@components/support/ConfirmationModal";
import { Broadcast } from "types";
import { showNotification } from "context/notification.service";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import Icon1 from "@assets/icons/Icon";
import { colors } from "sexy";

const statusTabs = [
  { value: "all", label: "Toutes" },
  { value: "active", label: "Actives" },
  { value: "inactive", label: "Inactives" },
];

export default function BroadcastsScreen() {
  const broadcasts = useProjectStore((state) => state.broadcasts);
  const removeBroadcasts = useProjectStore((state) => state.removeBroadcasts);
  const [table, setTable] = useState<any>(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [modifyBroadcast, setModifyBroadcast] = useState<Broadcast | null>(
    null,
  );
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("all");

  useEffect(() => {
    const table = transformBroadcastsToTable(broadcasts, activeTab);
    setTable(table);
  }, [broadcasts, activeTab]);

  const handleRowClick = (row: any) => {
    const broadcast = broadcasts.find((b) => b.id === row.id);
    if (broadcast) {
      setModifyBroadcast(broadcast);
    }
  };

  const handleDeleteSelected = () => {
    removeBroadcasts(selectedIds);
    showNotification({
      type: "success",
      message: `${selectedIds.length} annonce(s) supprimée(s)`,
    });
    setSelectedIds([]);
    setShowDeleteConfirm(false);
  };

  return (
    <div className="flex flex-col  overflow-auto max-h-screen">
      {createModalOpen && (
        <CreateBroadcastModal onClose={() => setCreateModalOpen(false)} />
      )}
      {modifyBroadcast && (
        <ModifyBroadcastModal
          onClose={() => setModifyBroadcast(null)}
          initialBroadcast={modifyBroadcast}
        />
      )}
      {showDeleteConfirm && (
        <ConfirmationModal
          title={`Supprimer ${selectedIds.length} annonce(s) ?`}
          message="Cette action est irréversible. Toutes les annonces sélectionnées seront supprimées définitivement."
          confirmText="CONFIRMER"
          onClose={() => setShowDeleteConfirm(false)}
          onConfirm={handleDeleteSelected}
        />
      )}
      <div className="flex flex-col h-fit pb-96 mt-10 ml-10">
        <div className="flex flex-col w-full max-w-1k gap-4">
          <div className="flex flex-row w-full justify-between">
            <div className="flex flex-col w-400">
              <Text1>Annonces</Text1>
              <Text2>Retrouvez toutes vos annonces ici.</Text2>
            </div>
            <div className="flex flex-row gap-2 items-start">
              {selectedIds.length > 0 && (
                <SecondaryButton
                  danger={true}
                  startIcon={
                    <Icon1 name="delete" size={22} color={colors.red_500} />
                  }
                  label={`Supprimer la sélection (${selectedIds.length})`}
                  variant="large"
                  onClick={() => setShowDeleteConfirm(true)}
                />
              )}
              <Button
                label="Nouvelle annonce"
                onClick={() => setCreateModalOpen(true)}
              />
            </div>
          </div>

          <div className="flex flex-col h-fit w-1k mt-4 gap-4">
            <div className="max-h-500">
              {table && (
                <DataGrid
                  selectable={true}
                  table={table}
                  hide_lines={true}
                  tabs={statusTabs}
                  activeTab={activeTab}
                  onTabChange={(tab) => setActiveTab(tab)}
                  onClick={handleRowClick}
                  handleSelectionModelChange={(ids) => setSelectedIds(ids)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
